import React from "react";
import Day from "features/CalendarView/Day";
import { DateHelper } from "../helpers/DateHelper";

export default function SchedulableDayShared(props) {
  const {
    isRed,
    itemType,
    selectedDate,
    setSelectedDate,
    activeDate,
    setActiveDate,
    date,
  } = props;

  function handleDayClick(event) {
    if (itemType === undefined || itemType === "appointment") {
      setSelectedDate(date);
    } else {
      setDates();
    }
  }

  function handleDayDoubleClick() {
    setActiveDate(date);
    setSelectedDate(date);
  }

  function setDates() {
    if (
      selectedDate.getTime() == date.getTime() ||
      (activeDate && activeDate.getTime() === date.getTime())
    ) {
      setActiveDate(null);
      setSelectedDate(date);
    } else if (selectedDate.getTime() < date.getTime()) {
      if (!activeDate) {
        setActiveDate(selectedDate);
      }
      setSelectedDate(date);
    } else if (!activeDate || activeDate.getTime() > date.getTime()) {
      setActiveDate(date);
    } else {
      // now on to dates inside the highlighting
      if (
        DateHelper.absDayDiff(date, selectedDate) <=
        DateHelper.absDayDiff(date, activeDate)
      ) {
        setSelectedDate(date);
      } else {
        setActiveDate(date);
      }
    }
  }

  return (
    <Day
      {...props}
      isRed={isRed}
      handleDayDoubleClick={
        itemType === "task" ? handleDayDoubleClick : undefined
      }
      handleDayClick={handleDayClick}
    />
  );
}
